import React from 'react'

import { Button, Image } from 'modules/ui'
import { checkIcon } from 'modules/ui/assets'
import Element from '../Element'
import enhance from './enhancers'

import imageTheme from './imageTheme.scss'

export function Review(props) {
  const { argument, strongest, theme, handleNewGame } = props
  const { evidence, reasoning, counterargument } = strongest

  return (
    <div className={theme.review}>
      <Image alt={argument.text} src={argument.imgUrl} theme={imageTheme}>
        <div className={theme.strongest}>
          <div className={theme.header}>
            <h3 className={theme.heading}>Your Strongest Argument</h3>

            <div className={theme.check}>
              <img alt="check icon" src={checkIcon} />
            </div>
          </div>

          <div className={theme.elements}>
            <Element text={evidence} type="evidence" />
            <Element text={reasoning} type="reasoning" />
            <Element text={counterargument} type="counterargument" />
          </div>
        </div>
      </Image>

      <section className={theme.action}>
        <Button
          onClick={handleNewGame}
          primary
          raised
          className={theme.button}
          label="New Game"
        />
      </section>
    </div>
  )
}

export default enhance(Review)



// WEBPACK FOOTER //
// ./client/modules/debate/components/Review/index.js